import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCustomFuelSurchargeTablesList extends Layout {
    layoutheaderCustomFSCList: LayoutHeader;
    sourceCustomFscHdr: DataSource;
    tableCustomFuelSurcharge: Table;
}
